// extracted by mini-css-extract-plugin
module.exports = {"containergrid":"LangingPage_containergrid__19lyW","header":"LangingPage_header__2kXSe","containerdiv":"LangingPage_containerdiv__4gWdn","ulli":"LangingPage_ulli__3Bk5j"};